module.exports = __webpack_public_path__ + "img/pc_tu.78487665.png";